import axiosInstance from './axios';

export interface QBOrderItemDetail {
  id: number;
  // Mirrors backend/app/schemas/bubbletea.py's QBOrderItemSummary.menu_item_id
  // -- always a bubble_tea_menu_items FK (this endpoint's `items` list only
  // ever contains BubbleTeaOrderItem rows; instant-cake lines live in a
  // separate, unexposed snapshot field, see BubbleTeaOrder.instant_cake_items_snapshot).
  // Used to re-resolve the localized (name_zh) menu item name against the
  // live quick-bites menu, since menu_item_name below is a flat English-only
  // string derived server-side with no _zh sibling.
  menu_item_id: number;
  menu_item_name: string;
  // task-025: zh sibling for menu_item_name -- populated server-side from
  // the live menu_item.name_zh column when the item still exists (even if
  // deactivated). Used as a localized fallback when the live qbMenu lookup
  // misses (menu item deactivated/deleted since the order).
  menu_item_name_zh: string | null;
  quantity: number;
  options: Record<string, string> | null;
}

export interface QBOrderDetail {
  id: number;
  status: string;
  queue_number: number | null;
  created_at: string;
  items: QBOrderItemDetail[];
}

export const customersAPI = {
  getMyQBOrders: async (): Promise<QBOrderDetail[]> => {
    const response = await axiosInstance.get('/customers/me/orders');
    return response.data;
  },
};
